import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["items", "itemId", "render", "children", "variant", "className", "classes"];
import * as React from 'react';
import clsx from 'clsx';
import { ListContext } from '../context';
var styles = {
  "root": "List-root_1rtA8",
  "default": "List-default_2WjzD",
  "compact": "List-compact_NRUsh",
  "bordered": "List-bordered_1gGDc"
};
function defaultItemId(item) {
  var key = item.uuid || item.id;
  if (!key) {
    return undefined;
  }
  return String(key);
}
function List(_ref) {
  var items = _ref.items,
    _ref$itemId = _ref.itemId,
    itemId = _ref$itemId === void 0 ? defaultItemId : _ref$itemId,
    render = _ref.render,
    children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    className = _ref.className,
    classes = _ref.classes,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  /**
   * Helper: allow to pass classes to component childs.
   */
  var classOf = function classOf(key) {
    var _classes$key;
    return (_classes$key = classes === null || classes === void 0 ? void 0 : classes[key]) !== null && _classes$key !== void 0 ? _classes$key : '';
  };
  var renderChildren = function renderChildren(item, index) {
    if (typeof render === 'function') {
      return render(item, index);
    }
    if (typeof children === 'function') {
      return children(item, index);
    }
    return null;
  };
  var rootClasses = clsx(styles.root, className, classOf('list'));
  var itemClass = clsx(styles.item, styles[variant], classOf('item'));
  var context = React.useMemo(function () {
    return {
      variant: variant
    };
  }, [variant]);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("ul", _extends({
      className: rootClasses
    }, extraProps), /*#__PURE__*/React.createElement(ListContext.Provider, {
      value: context
    }, items.map(function (item, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: itemId(item, i),
        className: itemClass
      }, renderChildren(item, i));
    })))
  );
}
export default List;